import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { Alert, Table } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import TableFooter from "../../../../components/TableFooter.jsx";
import genericTranslations from "../../../../utils/genericTranslations.js";
import { selectIsLoadingFolders, selectFolders } from "../../selectors.js";
import { fetchFolders } from "../../thunks.js";

const messages = defineMessages({
  broadcasts: {
    id: "modules.ArriVideo.components.Dashboard.broadcasts",
    description: "Broadcasts label",
    defaultMessage: "Broadcasts",
  },
});

const Folders = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const pageSize = 10;

  const folders = useSelector(selectFolders);
  const isLoading = useSelector(selectIsLoadingFolders);

  const fetchData = useCallback(async () => {
    try {
      const pagesFromResponse = await dispatch(
        fetchFolders({ page, pageSize }),
      );
      setPages(pagesFromResponse);
    } catch (err) {
      setError(err);
      setPage(1);
      setPages(0);
    }
  }, [dispatch, page, pageSize]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onSelectPage = (newPage) => {
    setPage(newPage);
  };

  const mapFolderToTableRow = (folder) => (
    <tr key={`folder-${folder.id}`}>
      <td>
        <Link to={`/arrivideo/folder/edit/${folder.id}`}>{folder.title}</Link>
      </td>
      <td>{folder.nrBroadcasts}</td>
      <td>{moment(folder.updatedAt).format("LLL")}</td>
    </tr>
  );

  const dismissError = () => setError(null);

  return (
    <div>
      {error && (
        <Alert variant="danger" onClose={dismissError} dismissible>
          <Alert.Heading>
            {intl.formatMessage(genericTranslations.errorMessage)}
          </Alert.Heading>
          <p>{error.toString()}</p>
        </Alert>
      )}

      {isLoading && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.loadingInProgress)}
        </span>
      )}

      {!isLoading && folders.length === 0 && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.nothingFound)}
        </span>
      )}

      {!isLoading && folders && folders.length > 0 && (
        <Table responsive>
          <thead>
            <tr>
              <td>{intl.formatMessage(genericTranslations.title)}</td>
              <td style={{ width: 150 }}>
                {intl.formatMessage(messages.broadcasts)}
              </td>
              <td style={{ width: 200 }}>
                {intl.formatMessage(genericTranslations.updatedAt)}
              </td>
            </tr>
          </thead>
          <tbody>{folders.map(mapFolderToTableRow)}</tbody>
        </Table>
      )}

      <TableFooter
        actionPath="/arrivideo/folder/add"
        onSelectPage={onSelectPage}
        page={page}
        pages={pages}
      />
    </div>
  );
};

Folders.propTypes = {
  // Since we're using hooks, no props are needed here
};

export default Folders;
